import { RootState } from '@/store'
import { Module } from 'vuex'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import { initialState, CustomerState } from './state'

export * from './state'

export const store: Module<CustomerState, RootState> = {
    state: initialState,
    actions,
    getters,
    mutations,
}
